import { CourseCombiInput, HoleInput } from 'livegolf_shared/lib/generated/graphql';
import React, { useState, useEffect } from 'react';
import { Modal } from 'react-native';
import { Stack, Text, Input, Button, RadioGroup, YStack, XStack, SizeTokens, Label, Separator, useMedia } from 'tamagui';
import { LGText } from '../../styles/StyledText';
import { LGUnit } from '../../types/types';
import { CourseService_GetCourse_CC_Data, CourseService_GetCourse_Data } from '../../services/CourseService';
import { HoleHelper } from '../../helpers/HoleHelper';

const labelWidth = "80px";



/*const AddHolesModal = ({ isVisible, initialIndex, onSubmitHoles, courseData, courseCombiData, onCanceled, numberOfHoles } : 
      { isVisible: boolean, initialIndex: number, onSubmitHoles: (data: Array<HoleInput>) => void, courseData: CourseService_GetCourse_Data, courseCombiData: CourseCombiInput, onCanceled: () => void, numberOfHoles: number}) => {
   const [holeIndex, setHoleIndex] = useState(initialIndex);
   const [par, setPar] = useState(4);
   const [_hcp, setHcp] = useState(0);
   const [length, setLength] = useState(0);
   const [holesData] = useState<Array<HoleInput>>([]);
   const media = useMedia();
*/
const AddHolesModal = ({
   isVisible,
   initialIndex,
   onSubmitHoles,
   courseData,
   courseCombiData,
   onCanceled,
   numberOfHoles,
   existingHoles,
   editMode = false
} : { 
   isVisible: boolean,
   initialIndex: number,
   onSubmitHoles: (data: Array<HoleInput>) => void,
   courseData: CourseService_GetCourse_Data,
   courseCombiData: CourseCombiInput,
   onCanceled: () => void,
   numberOfHoles: number,
   existingHoles?: Array<HoleInput> | null,
   editMode?: boolean
}) => {
   const [holeIndex, setHoleIndex] = useState(initialIndex);
   const [par, setPar] = useState(4);
   const [_hcp, setHcp] = useState(0);
   const [length, setLength] = useState(0);
   const [holesData, setHolesData] = useState<Array<HoleInput>>([]);
   const media = useMedia();
   const getHcpFromExistingCourseCombi = (holeIndex, zeroIfTaken = false) =>
   {
      if(!courseData || !courseCombiData)
      {
         return 0;
      }

      var matchingCourseCombi : CourseService_GetCourse_CC_Data | null = null;
      
      if(courseData.course_combis && courseData.course_combis.length > 0)
      {
         for(var i=0; i<courseData.course_combis.length; ++i)
         {
            matchingCourseCombi = courseData.course_combis[i];
            if(courseData.course_combis[i].gender_id == courseCombiData.gender_id)
            {
               break;
            }
         }
      }

      if(matchingCourseCombi)
      {
         if(!matchingCourseCombi.holes || !matchingCourseCombi.holes[holeIndex] || (zeroIfTaken && ccHasHcpAlready(matchingCourseCombi.holes[holeIndex].hcp)))
         {
            return 0;
         }
         return matchingCourseCombi.holes[holeIndex].hcp;
      }
   }

   useEffect(() => {
      if (!isVisible) {
         return;
      }

      const startIndex = initialIndex ?? 0;
      setHoleIndex(startIndex);

      if (editMode && existingHoles && existingHoles.length > 0) {
         const clonedHoles = existingHoles
            .map(hole => ({
               course_id: hole.course_id,
               tee_id: courseCombiData.tee_id,
               hole_index: hole.hole_index,
               par: hole.par,
               hcp: hole.hcp,
               length: hole.length
            }))
            .sort((a, b) => a.hole_index - b.hole_index);

         setHolesData(clonedHoles);

         const firstHole = getHoleByUiIndex(clonedHoles, startIndex);

         if (firstHole) {
            setPar(firstHole.par);
            setHcp(firstHole.hcp);
            setLength(firstHole.length);
         }

         return;
      }

      setHolesData([]);
      setPar(4);
      setHcp(getHcpFromExistingCourseCombi(startIndex, true));
      setLength(0);
   }, [isVisible, existingHoles, editMode, initialIndex, courseCombiData?.tee_id]);

   const handleLengthChange = (value) => {

      let intValue = value ? parseInt(value) : 0;
      setLength(intValue);

      if(courseCombiData.unit == LGUnit.yards)
      {
         intValue = Math.round(intValue * 0.9144);
      }

      setPar(HoleHelper.getSuggestedParFromLength(intValue, courseCombiData.gender_id));
   }

   const isDataValid = () =>
   {
      const savedHoles = getSavedHolesData();

      if (savedHoles.length < numberOfHoles) {
         return false;
      }

      for (let i = 0; i < numberOfHoles; ++i) {
         if (!savedHoles[i] || savedHoles[i].hcp == 0) {
            return false;
         }
      }

      return true;
   }
   /*const isDataValid = () =>
   {
      if((holesData.length == numberOfHoles-1 && !currentHoleHasValidData()) || holesData.length < numberOfHoles)
      {
         return false;
      }

      for(let i = 0; i < holesData.length; ++i)
      {
         if(holesData[i].hcp == 0)
         {
            return false;
         }
      }

      return true;
      //return holesData.length == numberOfHoles || (holesData.length == numberOfHoles-1 && currentHoleHasValidData());
   }*/

   const cancelAdd = () =>
   {
      onCanceled();
   }

   const hcpIsUsedByOtherHole = (hcp: number) => {
      const currentDbHoleIndex = holeIndex + 1;

      return holesData.some(hole =>
         hole.hole_index !== currentDbHoleIndex &&
         hole.hcp === hcp
      );
   }
   
   const ccHasHcpAlready = (hcp: number) => {
      const currentDbHoleIndex = holeIndex + 1;

      for (let i = 0; i < holesData.length; ++i) {
         if (holesData[i].hole_index !== currentDbHoleIndex && hcp == holesData[i].hcp) {
            return true;
         }
      }

      return false;
   }

   const onHcpChanged = (value: string) => {
      const newHcp = parseInt(value);
      const currentDbHoleIndex = getDbHoleIndex(holeIndex);

      setHcp(newHcp);

      setHolesData(prev => {
         return prev.map(hole => {
            if (hole.hole_index !== currentDbHoleIndex && hole.hcp === newHcp) {
               return {
                  ...hole,
                  hcp: 0
               };
            }

            return hole;
         });
      });
   }

   const renderHcpRadioGroup = () =>
   {
      const RadioGroupArray = [];

      const rows = 2;
      //const columns = numberOfHoles/rows;

      for(let row=1; row<3; ++row)
      {
         const curArray = [];
         for (let x1=row; x1<=numberOfHoles; x1+=2)
         {
            curArray.push(
               <RadioGroupItemWithLabel 
                  groupId="hcp"
                  key={`hcp-${x1}`} 
                  size={media.xs ? "$2" : "$3"} 
                  isUsed={hcpIsUsedByOtherHole(x1)}
                  value={String(x1)} 
                  label={String(x1)} 
               />
            );
         }

         RadioGroupArray.push(curArray);
      }

      return (
         <YStack>
            <LGText px="8px" w={labelWidth}>Hcp</LGText>
            <RadioGroup
               pt="8px"
               value={String(_hcp)}
               defaultValue="0"
               onValueChange={onHcpChanged}
            >
               <YStack>
                  <XStack>
                  {RadioGroupArray[0]}
                  </XStack>
                  <XStack>
                  {RadioGroupArray[1]}
                  </XStack>
               </YStack>
            </RadioGroup>
         </YStack>
         )
   }

   const canGoToPreviousHole = () =>
   {
      return holeIndex > 0;
   }

   const currentHoleHasValidData = () =>
   {
      return _hcp != 0;
   }

   const canGoToNextHole = () =>
   {
      return holeIndex < numberOfHoles-1;
   }
   
   /*const saveCurrentHoleData = () => {
      const newHole: HoleInput = {
         hole_index: holeIndex,
         course_id: editMode && existingHoles?.[holeIndex]?.course_id
            ? existingHoles[holeIndex].course_id
            : courseData.id,
         tee_id: courseCombiData.tee_id,
         hcp: _hcp,
         par: par,
         length: length
      };

      setHolesData(prev => {
         const next = [...prev];

         if (next.length > holeIndex) {
            next[holeIndex] = newHole;
         } else {
            next.push(newHole);
         }

         return next;
      });

      return newHole;
   }
*/
   const getDbHoleIndex = (uiHoleIndex: number) => {
      return uiHoleIndex + 1;
   }

   const getHoleByUiIndex = (holes: Array<HoleInput>, uiHoleIndex: number) => {
      const dbHoleIndex = getDbHoleIndex(uiHoleIndex);
      return holes.find(hole => hole.hole_index === dbHoleIndex);
   }

   const setHoleByUiIndex = (holes: Array<HoleInput>, uiHoleIndex: number, hole: HoleInput) => {
      const dbHoleIndex = getDbHoleIndex(uiHoleIndex);
      const next = [...holes];

      const existingIndex = next.findIndex(h => h.hole_index === dbHoleIndex);

      if (existingIndex >= 0) {
         next[existingIndex] = hole;
      } else {
         next.push(hole);
      }

      return next.sort((a, b) => a.hole_index - b.hole_index);
   }

   const getSavedHolesData = () => {
      const dbHoleIndex = getDbHoleIndex(holeIndex);
      const existingHole = getHoleByUiIndex(holesData, holeIndex);

      const newHole: HoleInput = {
         hole_index: dbHoleIndex,
         course_id: existingHole?.course_id ?? courseData.id,
         tee_id: courseCombiData.tee_id,
         hcp: _hcp,
         par: par,
         length: length
      };

      return setHoleByUiIndex(holesData, holeIndex, newHole);
   }

   const submitData = () => {
      onSubmitHoles(getSavedHolesData());
   }

   const goToNextHole = () => {
      const savedHoles = getSavedHolesData();
      setHolesData(savedHoles);

      const nextIndex = holeIndex + 1;
      const nextHole = getHoleByUiIndex(savedHoles, nextIndex);

      if (nextHole) {
         setPar(nextHole.par);
         setHcp(nextHole.hcp);
         setLength(nextHole.length);
      } else {
         setPar(4);
         setHcp(getHcpFromExistingCourseCombi(nextIndex, true));
         setLength(0);
      }

      setHoleIndex(nextIndex);
   }

   const goToPreviousHole = () => {
      const savedHoles = getSavedHolesData();
      setHolesData(savedHoles);

      const prevIndex = holeIndex - 1;
      const prevHole = getHoleByUiIndex(savedHoles, prevIndex);

      if (prevHole) {
         setPar(prevHole.par);
         setHcp(prevHole.hcp);
         setLength(prevHole.length);
      }

      setHoleIndex(prevIndex);
   }

   /*const getHoleByUiIndex = (holes: Array<HoleInput>, uiIndex: number) => {
      const dbHoleIndex = uiIndex + 1;
      return holes.find(hole => hole.hole_index === dbHoleIndex);
   }*/

   const calculateCoursePar = () =>
   {
      const savedHoles = getSavedHolesData();

      let totalPar = 0;
      for(let i = 0; i < savedHoles.length; ++i)
      {
         totalPar += savedHoles[i].par;
      }

      return totalPar;
   }

   const calculateCourseLength = () =>
   {
      const savedHoles = getSavedHolesData();

      let totalLength = 0;
      for(let i = 0; i < savedHoles.length; ++i)
      {
         totalLength += savedHoles[i].length;
      }

      if(courseCombiData.unit == LGUnit.meters)
      {
         return totalLength;
      }
      else
      {
         return Math.round(totalLength * 0.9144);
      }
   }

   return (
      
      <Modal animationType="none" transparent={true} visible={isVisible} onRequestClose={submitData}>
         { courseData && courseCombiData &&
         <Stack flex={1}>
            <Stack flex={1} justifyContent="center" alignItems="center">
               <Stack bg="#EEE" p={4} borderRadius={6} borderWidth={1} shadowOffset={{ width: 3, height: 3 }} shadowColor="#000" shadowOpacity={0.25} shadowRadius={4} alignItems='center'>
                  <LGText>Course: {courseData.name}</LGText>
                  <LGText>Tee: {courseCombiData.tee_name}</LGText>
                  <LGText>Hole {holeIndex+1}</LGText>
                  <Stack>
                     <Stack alignItems='center' justifyContent='center'>
                        <XStack px="8px" pt="8px" w="100%">
                           <LGText w={labelWidth}>Length</LGText>
                           <Separator />
                           <Input
                              flex={1}
                              placeholder="Enter Length"
                              keyboardType="number-pad"
                              value={String(length)}
                              onChangeText={handleLengthChange}
                              
                           />
                        </XStack>

                        <XStack px="8px" pt="8px" w="100%">
                           <LGText w={labelWidth}>Par</LGText>
                           <Separator />
                           <RadioGroup value={String(par)} defaultValue="4" onValueChange={(value) => {
                                 setPar(parseInt(value));
                           }}>
                              <XStack>
                                 <RadioGroupItemWithLabel groupId="par" size="$3" value="3" label="3" />
                                 <RadioGroupItemWithLabel groupId="par" size="$3" value="4" label="4" />
                                 <RadioGroupItemWithLabel groupId="par" size="$3" value="5" label="5" />
                              </XStack>
                           </RadioGroup>
                        </XStack>
                        { renderHcpRadioGroup()}
                        
                     </Stack>
                  </Stack>
                  <XStack alignContent='center' justifyContent='center' space="$4">
                     <LGText> Course Par: {calculateCoursePar()}</LGText>
                     <LGText> Length: {calculateCourseLength()}m/{Math.round(calculateCourseLength()*1.09361)}y</LGText>
                  </XStack>
                  <XStack>
                     <Button onPress={cancelAdd}>
                        <Text>Cancel</Text>
                     </Button>
                     <Button onPress={goToPreviousHole} disabled={!canGoToPreviousHole()}>
                        <Text>Previous Hole</Text>
                     </Button>
                     <Button onPress={goToNextHole} disabled={!canGoToNextHole()}>
                        <Text>Next Hole</Text>
                     </Button>
                     <Button onPress={submitData} disabled={!isDataValid()}>
                        <Text>Submit</Text>
                     </Button>
                  </XStack>
               </Stack>
            </Stack>
         </Stack>
      }
      </Modal>
      
   );
};


function RadioGroupItemWithLabel(props: {
   groupId: string
   size: SizeTokens
   value: string
   label: string
   isUsed?: boolean
 }) {
   const id = `${props.groupId}-radiogroup-${props.value}`

   return (
     <XStack width={40} alignItems="center" space="$1" bg={props.isUsed ? "orange" : null}>
       <RadioGroup.Item value={props.value} id={id} size={props.size}>
         <RadioGroup.Indicator />
       </RadioGroup.Item>
 
       <Label size={props.size} htmlFor={id}>
         {props.label}
       </Label>
     </XStack>
   )
}

 
export default AddHolesModal;

